import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { paletteOptions } from "@portal/app/_components/theme/options/palette";
import HomepageLogoNursejournal from "@portal/app/_components/resources/images/homepage_logo_nursejournal.webp";
import HomepageLogoYahoo from "@portal/app/_components/resources/images/homepage_logo_yahoo.webp";
import HomepageLogoForbes from "@portal/app/_components/resources/images/homepage_logo_forbes.webp";
import HomepageLogoEntrepreneur from "@portal/app/_components/resources/images/homepage_logo_entrepreneur.webp";

export const HomeFeaturedOnSection = () => (
  <Section>
    <SectionLabel>As featured in</SectionLabel>
    <ImageRow>
      <img alt="Yahoo logo" className="yahoo" src={HomepageLogoYahoo.src} loading="lazy" />
      <img
        alt="Entrepreneur logo"
        className="entrepreneur"
        src={HomepageLogoEntrepreneur.src}
        loading="lazy"
      />
      <img alt="Forbes logo" className="forbes" src={HomepageLogoForbes.src} loading="lazy" />
      <img
        alt="NurseJournal logo"
        className="nursejournal"
        src={HomepageLogoNursejournal.src}
        loading="lazy"
      />
    </ImageRow>
  </Section>
);

const Section = styled("section")`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 1rem;
  border-top: 1px solid ${paletteOptions.dream.borderColor};
  border-bottom: 1px solid ${paletteOptions.dream.borderColor};
`;

const SectionLabel = styled(Typography)`
  text-transform: uppercase;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  color: ${paletteOptions.secondary.dark};
  margin-bottom: 0;
`;

const ImageRow = styled("div")`
  margin-top: 1rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
  width: 100%;

  .yahoo {
    height: 4rem;
  }

  .entrepreneur {
    height: 3.5rem;
    margin: 0.25rem 0;
  }

  .forbes {
    height: 2.4rem;
    margin: 0.8rem 0;
    filter: grayscale(1);
  }

  .nursejournal {
    height: 2.2rem;
    margin: 1.8rem 0;
  }

  img {
    opacity: 0.8;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: 0;
    padding: 0.5rem 1rem;
    flex-direction: column;
    gap: 2rem;

    img {
      margin: 0;
    }
  }
`;
